'use strict';

import React, { Component } from 'react'

import { CSSTransition, TransitionGroup } from 'react-transition-group'

import _ from 'lodash'

import Layout from '@Layout/BackOffice'

import UpdateForm from '@/Form/UpdateForm'

import DataList from '@/DataList'

import Geocoder from '@/Maps/Geocoder'

import { form as _config } from '@Config/Catalog/partner'
import _EC_member_config  from '@Config/EC/EC_member'

let config = _.cloneDeep(_config);

const { app, qwest } = window;

export default class PartnerPage extends Component
{
	state =
	{
		admin_users: [],
		admin_users_references: []
	};

	init = () =>
	{
		const component = this;

		config.hookOnUpdate = function (e, data)
		{
			const _component = this, _props = this.props, _state = this.state;

			const state = component.state;

			let fields = ['city', 'line_1', 'line_2', 'zip_code', 'place'];

			let update = fields.find(function (field)
			{
				let db_field = field;

				switch (field)
				{
					case 'line_1':
						db_field = 'address_1';
					break;

					case 'line_2':
						db_field = 'address_2';
					break;
				}

				return _state.form_data['partner' + '[' + db_field + ']'] !== state[field];
			});

			if (!update || state.ready !== true) return;

			component.setState(
			{
				line_1: _state.form_data['partner[address_1]'],
				line_2: _state.form_data['partner[address_2]'],
				zip_code: _state.form_data['partner[zip_code]'],
				city: _state.form_data['partner[city]'],

				place: _state.form_data['partner[place]']
			});
		}

		config.hookGetDataAjax = function (form_data, response)
		{
			const _component = this, _props = this.props, _state = this.state;

			let partner = response.data || { };

			component.setState(
			{
				ready: true,
				geocoding: partner.geocoding,

				line_1: partner.address_1,
				line_2: partner.address_2,
				zip_code: partner.zip_code,
				city: partner.city,

				place: partner.place,
			});
		};

		config.form_title = 'Modification d\'un partenaire';

		config.formTitleHook = function (model_data)
		{
			return model_data['partner[name]'];
		}
	}

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.resetFunctions();

		let id = document.location.pathname.split('/');

		id = id[id.length-1] ? id[id.length-1] : id[id.length-2];

		if (!id) return;

		qwest.post('/CMS/getAll',
		{
			model: 'user',
			filter_query: JSON.stringify({ partners: id })
		})
		.then(function (xhr, response)
		{
			component.setState(
			{
				admin_users: response.data || [],
				admin_users_references: response.references || []
			});
		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);
		});
	}

	componentDidUpdate (prev_props, prev_state)
	{
		const component = this, props = this.props, state = this.state;

		if (prev_state.place !== state.place || prev_state.ready !== true)
		{
			if (state.place)
			{
				let id = document.location.pathname.split('/');

				id = id[id.length-1] ? id[id.length-1] : id[id.length-2];

				qwest.post('/partner/update-geocoding',
				{
					id: id,
					geocoding: null
				})
				.then(function (xhr, response)
				{
					console.info(response);
				})
				.catch(function (error, xhr, response)
				{
					console.error(error);
				});
			}
		}
	}

	handleAddressChange = (geocoding) =>
	{
		let form_data = new FormData();

		let id = document.location.pathname.split('/');

		id = id[id.length-1] ? id[id.length-1] : id[id.length-2];

		qwest.post('/partner/update-geocoding',
		{
			id: id,
			geocoding: geocoding
		})
		.then(function (xhr, response)
		{
			console.info(response);
		})
		.catch(function (error, xhr, response)
		{
			console.error(error);
		});
	}

	duplicate = () =>
	{
		const component = this, props = this.props, state = this.state;

		let id = document.location.pathname.split('/');

		id = id[id.length-1] ? id[id.length-1] : id[id.length-2];

		qwest.post('/partner/duplicate', { id: id })
		.then(function (xhr, response)
		{
			window.open(document.location.pathname
				.replace(id, response.created_partner.id)
			);
		})
		.catch(function (error, xhr, response)
		{
			console.error(error);
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let EC_member_config = _.cloneDeep(_EC_member_config);

		let admin_users, title = 'Administrateurs du partenaire';

		delete EC_member_config.creation_link;
		delete EC_member_config.creation_label;

		EC_member_config.title = title;

		if (state.admin_users.length > 0)
		{
			admin_users =
			(
				<DataList config={ EC_member_config } data={ state.admin_users }
					references={ state.admin_users_references } add_btn={ false } />
			);
		}
		else
		{
			admin_users =
			(
				<div className="c-title c-title--link">
					<h2 className="c-title__txt">{ title }</h2>
				</div>
			);
		}

		const address =
		{
			name: state.name,
			line_1: state.line_1,
			line_2: state.line_2,
			zip_code: state.zip_code,
			city: state.city
		};

		let geocoder;

		if (state.place)
		{
			geocoder =
			(
				<div className="c-message c-message--green">
					<div className="c-message__content">
						Le Google Maps du lieu sera utilisé pour ce partenaire.
					</div>
				</div>
			);
		}
		else if (state.ready)
		{
			if (state.name || state.line_1)
			{
				geocoder =
				(
					<Geocoder address={ address } geocoding={ state.geocoding }
						onChange={ component.handleAddressChange } />
				);
			}
			else
			{
				geocoder =
				(
					<div className="c-message c-message--green">
						<div className="c-message__content">
							Le Google Maps a besoin d'une adresse renseignée.
						</div>
					</div>
				);
			}
		}

		let id = document.location.pathname.split('/');

		id = id[id.length-1] ? id[id.length-1] : id[id.length-2];

		var output =
		(
			<Layout page_title="Modifier un partenaire" hide_title={ true }
				history={ props.history }>

				<div className="page-content">

					<div className="o-content">

						<div className="u-flex u-content-between u-margin-bottom-15">

							<button onClick={ component.duplicate }
								className="c-btn c-btn--primary" target="_blank">
								Dupliquer vers un nouveau partenaire
							</button>

							<a href={ '/partenaire/pdf/' + id }
								className="c-btn c-btn--primary" target="_blank">
								Télécharger la plaquette
							</a>

						</div>

						<TransitionGroup className="u-full-width">

							<CSSTransition
								classNames="a-form-transition"
								appear={ true }
								enter={ true }
								exit={ true }
								timeout={{ enter: 240, exit: 320, appear: 500 }}>

								<UpdateForm className="u-no-margin-top"
									config={ config }>

									<div className="o-content u-margin-top-20"
										style={ { order: -10 } }>
										{ geocoder }
									</div>

								</UpdateForm>


							</CSSTransition>

						</TransitionGroup>

						{ admin_users }

					</div>

				</div>

			</Layout>
		);

		return output;
	}
}